import axiosConfig from '../modules/axiosConfig'
import utils from '../modules/utils'
const HTTP = axiosConfig.HTTP

// state
const state = {
  loadingCheckId: false
}

// getters
const getters = {
  getloadingCheckId () {
    return state.loadingCheckId
  }
}

// actions
const actions = {
  async checkID ({ commit, rootState }, data) {
    commit('LOADING_CHECKID_FINISHED', false)
    const config = rootState.appConfig.configFile
    const appParams = JSON.parse(sessionStorage.getItem('appParams'))
    // const appProgram = sessionStorage.getItem('appProgram')
    const storageAppToken = sessionStorage.getItem('token')
    const hashToken = utils.SHA256(appParams.entidad + storageAppToken + appParams.canal)
    let body = {}
    if (typeof data !== 'undefined') {
      body = Object.assign({}, {
        runService: {
          opData: {
            avanzar: data.avanzar ? data.avanzar : false,
            businesstimeout: '',
            canal: config.canal,
            claveFin: data.claveFin ? data.claveFin : '',
            claveInicio: data.claveInicio ? data.claveInicio : '',
            entidad: config.entidad,
            idioma: 'ES',
            indMasDatos: '',
            oficina: '',
            pantPagina: '',
            retroceder: data.retroceder ? data.retroceder : false,
            mainUser: appParams.mainUser,
            securityToken: hashToken
          },
          eEntrada: {
            apellid1: '',
            apellid2: '',
            codentid: '',
            codpostal: '',
            codprogr: '',
            codregion: '',
            desclave1: '',
            desclave2: '',
            fecnac: '',
            idclient: data.idClient ? data.idClient : '',
            indestciv: '',
            indexiste: '',
            nombre: '',
            poblacion: '',
            sexo: '',
            tipidcli: data.tipidcli ? data.tipidcli : '',
            tipmedio1: '',
            tipmedio2: ''
          }
        }
      })
    }
    try {
      const response = await HTTP.post(config.endpoints.checkId, body)
      sessionStorage.setItem('token', response.data.runServiceResponse.return.securityToken)
      commit('LOADING_CHECKID_FINISHED', true)
      if (response.data.runServiceResponse.return.retorno === '039') {
        commit('SET_ERROR', {
          isError: true,
          isFatal: true,
          msg: 'La sesión ha expirado. Reinicie el registro.'
        })
      }
      if (response.data.runServiceResponse.return.retorno === '021') {
        commit('SET_ERROR', {
          isError: true,
          isFatal: true,
          msg: 'Token de seguridad incorrecto.'
        })
      }
      return response.data.runServiceResponse.return
    } catch (error) {
      commit('SET_ERROR', {
        isError: true,
        isFatal: false,
        msg: error
      }, { root: true })
    }
  }
}

// mutations
const mutations = {
  'LOADING_CHECKID_FINISHED' (state, actions) {
    state.loadingCheckId = actions
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
